import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import Radio from './radio';

class RadioGroup extends React.Component {
  static propTypes = {}
  static defaultProps = {}
  state ={

  }
  render = () => {
    const { options, name, handleOnChange, selectedValue } = this.props;
    return (
      <div className={styles.radioGroupParent}>
        {options.map(option => (
          <Radio
            key={option.value}
            name={name}
            label={option.label}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={e => handleOnChange(e.target)}
          />
        ))}

      </div>
    );
  }
}

export default RadioGroup;

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  handleOnChange: PropTypes.func,
  name: PropTypes.string,
  selectedValue: PropTypes.string,
};

RadioGroup.defaultProps = {
  options: [],
  handleOnChange: undefined,
  name: '',
  selectedValue: '',
};
